import { render, staticRenderFns } from "./RadioSwitcher.vue?vue&type=template&id=35e5054f&"
import script from "./RadioSwitcher.vue?vue&type=script&lang=js&"
export * from "./RadioSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports